<template>
  <div>
    <slot name="page-header"></slot>
    <slot name="page-banner"></slot>
    <slot name="breadcrumb"></slot>
    <div class="big-screen" :class="isDefaultPage?'pt-6':'pt-6'">
      <div v-if="sectionSequence == 1">
        <slot name="dummy-courses-1"></slot>
        <slot name="dummy-courses-2"></slot>
        <slot name="my-courses"></slot>
        <slot name="other-courses"></slot>
        <slot name="page-canvas"></slot>
      </div>
      <div v-else>
        <slot name="page-canvas"></slot>
        <slot name="dummy-courses-1"></slot>
        <slot name="dummy-courses-2"></slot>
        <slot name="my-courses"></slot>
        <slot name="other-courses"></slot>
      </div>
    </div>
    <slot name="page-footer"></slot>
  </div>
</template>
<script>
export default {
  name: 'PageMarkup',
  data() {
    return {};
  },
  props: {
    sectionSequence: {},
    isDefaultPage:{}
  },
};
</script>